import { Button } from '@/components/Button'
import { Loader } from '@/components/Loader'
import { Icon } from '@/icons'
import { popupAuthStore } from '@/store/PopupAuth.store'
import { observer } from 'mobx-react-lite'
import cn from 'classnames'
import { FC } from 'react'
import styles from './Account.module.scss'

interface AccountButtonProps {
  className?: string
}
export const AccountButton: FC<AccountButtonProps> = observer(() => {
  return (
    <Button
      onClick={popupAuthStore.show}
      className={styles.button}
      disabled={popupAuthStore.loadCheckAuth}
    >
      <Icon
        name="user"
        className={cn(styles.userIcon, {
          [styles.isDisabled]: popupAuthStore.loadCheckAuth,
        })}
      />
      Войти
      {popupAuthStore.loadCheckAuth ? (
        <Loader onTop className={styles.loader} />
      ) : null}
    </Button>
  )
})
